import '../../utils/index.mjs';
import Space from './src/space.mjs';
export { spaceProps } from './src/space.mjs';
export { useSpace } from './src/use-space.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElSpace = withInstall(Space);

export { ElSpace, ElSpace as default };
//# sourceMappingURL=index.mjs.map
